<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/160dbME/tc-custom/9781488018503.jpg?1718170133116" alt="This image is the cover for the book Cowboy's Baby Blessing, Cowboy Country"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cowboy's Baby Blessing, Cowboy Country
      </h1>
      <p class="bookDescription body article font2">
        <b>The Rancher's New Family </b><br/><br/>Rachel Perez needs a handyman to spruce up her in-home day care. So when she "wins" ex-soldier Seth Howell in a bachelor auction, she's glad he can swing a hammer. But when freewheeling Seth suddenly inherits a two-year-old and a sprawling ranch, he's got to grow up fast. Seth admires Rachel's kindness and easy way with kids, so he seeks her help in finding his footing as a father. And single mom Rachel sees how determined Seth is to do right by little Caden. Between his toddler and her teenager, they've got plenty of responsibilities. Finding time for love seems out of the questionbut soon they're forging a new familytogether.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deb Kastner
      </h2>
      
      <p class="authorDescription body article">~Love Courageously~Award-winning author Deb Kastner writes stories of faith, family and community in a small-town western setting. &#160;Deb&rsquo;s books contain sigh-worthy heroes and strong heroines facing obstacles that draw them closer to each other and the Lord. She lives in Colorado with her husband. She is blessed with three grown daughters and two grandchildren. She enjoys spoiling her grandkids, movies, music, reading, musical theater and exploring Colorado on horseback.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee25147a